import { Link, useNavigate } from "react-router-dom"
import DashboardSideBar from "../../components/dashboardSidebar"
import Footer from "../../components/footer"
import Header from "../../components/header"
import SideBar from "../../components/sidebar"
import services from "../../services"
import { useEffect, useState } from "react"
import Toaster from "../../components/toaster";

import { isMobile } from 'react-device-detect';
import constant from "../../constant";
import moment from "moment";
import { TripTypeBadge, KmBadge, CostHighlight } from "../../components/bookingMeta";
import useIsMobile from "../../hooks/useIsMobile";
import MobileFooter from "../../components/MobileFooter";
import MobileHeader from "../../components/MobileHeader";
const Dashboard = () => {
    const navigate = useNavigate()
    const isMobileView = useIsMobile()
    const [bookingList, setBookingList] = useState([])
    const [pendingbooking, setpendingbooking] = useState(0)
    const [driverList, setDriverList] = useState()
    const [selectedDriver, setSelectedDriver] = useState()

    const [completedbooking, setcompletedbooking] = useState(0)
    const [upcomingbooking, setupcomingbooking] = useState(0)
    const [carcount, setcarcount] = useState(0)
    const [totalamount, settotalamount] = useState(0)
    const [todayOneWay, setTodayOneWay] = useState([])
    const [oneWayStats, setOneWayStats] = useState({ activeCount: 0, totalCount: 0, completedCount: 0, completedEarnings: 0 })
    const [toaster, setToaster] = useState({ visiblity: "hide" });
    const [isOnline, setIsOnline] = useState(true)
    const [onlineLoading, setOnlineLoading] = useState(false)

    const fetchOnlineStatus = async () => {
        try {
            const res = await services.Vendor.GET_VENDOR();
            const v = res?.data?.VendorDetail || res?.data?.vendorDetail || res?.data;
            if (v && typeof v.isOnline !== 'undefined') setIsOnline(v.isOnline !== false);
        } catch (e) { /* keep default */ }
    }
    const toggleOnline = async () => {
        const next = !isOnline;
        setOnlineLoading(true);
        setIsOnline(next); // optimistic
        try {
            await services.Vendor.SET_ONLINE_STATUS({ isOnline: next });
        } catch (e) {
            setIsOnline(!next); // revert on failure
        } finally {
            setOnlineLoading(false);
        }
    }

    const fetchOneWayStats = async () => {
        try {
            const res = await services.Vendor.GET_ONE_WAY_STATS();
            if (res?.data) setOneWayStats(res.data);
        } catch (e) { /* keep zeros */ }
    }

    // Today's bookable one-way trips: dated today, switched on, not yet completed
    const fetchTodayOneWay = async () => {
        try {
            const res = await services.Vendor.GET_ALL_ONE_WAY_AVAILABILITIES();
            const list = Array.isArray(res?.data) ? res.data : res?.data?.rows || [];
            setTodayOneWay(list.filter((a) => a.isActive && !a.isCompleted && moment(a.tripDate).isSame(moment(), 'day')));
        } catch (e) { /* keep empty */ }
    }
    const oneWayFare = (a) => {
        const pk = Number(a.vendorCar?.perKmCharge || a.vendorCar?.Car?.perKmCharge || 0);
        return a.distanceMeters && pk ? Math.round((a.distanceMeters / 1000) * pk) : null;
    }

    useEffect(() => {
        getBookingsHandler();
        getDriverData();
        fetchOnlineStatus();
        fetchOneWayStats();
        fetchTodayOneWay();
    }, [])

    // One-way trips are added to earnings using the estimated fare shown to the customer
    const earningsTotal = totalamount + (oneWayStats.completedEarnings || 0)
    const completedTotal = completedbooking + (oneWayStats.completedCount || 0)
    const hasEstimated = (oneWayStats.completedCount || 0) > 0
    const getDriverData = async() =>{
        try {
            const response = await services.Vendor.GET_DRIVER();
            console.log(response)
            setDriverList(response.data)
        } catch (error) {
            console.log(error)
        }
    }
    const getBookingsHandler = async () => {
        try {
            const response = await services.order.BOOKING_REQUESTS();
            const responseAll = await services.order.BOOKING_LISTING();
            const cars = await services.Cars.GET_VENDOR_CAR();
            setcarcount(cars.data.length)
            let data = responseAll.data;
            let total = 0
            if (response.data.length) {
                response.data.map((item) => {
                    item.BookingDetails.sort(function (a, b) {
                        return parseFloat(a.id) - parseFloat(b.id);
                    });

                })
                console.log(response.data)
                setBookingList(response.data)
            }
            if (data.length) {
                data.map((item) => {
                    item.BookingDetails.sort(function (a, b) {
                        return parseFloat(a.id) - parseFloat(b.id);
                    });

                })

                var newArray = data.filter(function (el) {
                    return el.BookingDetails[0].bookingStatus == 'confirmed' || el.BookingDetails[0].bookingStatus == 'accepted';
                });
                var ended = data.filter(function (el) {
                    return el.BookingDetails[0].bookingStatus == 'ended';
                });
                ended.map((item) => {
                    item?.BookingDetails[0]?.BookingPayment?.BookingPaymentDetails?.map((payment) => {
                        if (payment.transactionData?.razorpay_payment_id) {
                            total = total + (payment.amount / 100);
                        } else {
                            total = total + payment.amount
                        }
                    })
                })
                var pending = data.filter(function (el) {
                    return el.BookingDetails[0].bookingStatus == 'pending';
                });
                settotalamount(total)
                setupcomingbooking(newArray.length)
                setcompletedbooking(ended.length)
                setpendingbooking(pending.length)

            }
        } catch (error) {
            console.log(error)
        }
    }
    const acceptBookingHandler = async (item) => {
        try {
            const isConfirm = window.confirm('Are you sure you want to accept?')
            console.log(isConfirm)
            if (isConfirm) {
                let data = { bookingId: item.id, assignDriver: selectedDriver }
                const response = await services.order.ACCEPT_BOOKING(data)
                console.log(response)
                if (response) {
                    navigate('/mybookings')
                }
            }
        } catch (error) {
            console.log(error)
            if (error.response.data.message == "Vendor car does not exists!")
                setToaster({
                    type: "danger",
                    title: "Pending profile",
                    text: 'Driver is not assigned to this car!',
                    visiblity: "show",
                });

        }
    }
    const rejectBookingHandler = async (item) => {
        try {
            const isConfirm = window.confirm('Are you sure you want to reject?')
            console.log(isConfirm)
            if (isConfirm) {
                const response = await services.order.REJECT_BOOKING(item.id)
                console.log(response)
                if (response) {
                    navigate('/mybookings')
                }
            }
        } catch (error) {
            console.log(error)
        }
    }
    if (isMobileView) {
        let user = {};
        try { user = JSON.parse(localStorage.getItem('user_id')) || {}; } catch (e) { user = {}; }
        return (
            <>
                <Toaster type={toaster.type} title={toaster.title} text={toaster.text} visiblity={toaster.visiblity} />
                <SideBar />
                <main className="mlux">
                    <MobileHeader right={<Link to="/myprofile" className="mlux-avatar"><i className="far fa-user"></i></Link>} />
                    <div className="mlux-greet" style={{ margin: '8px 4px 2px' }} data-rise="1">
                        <div className="kick">Welcome back</div>
                        <div className="nm" style={{ fontSize: 24 }}>{user?.firstName ? `Hi, ${user.firstName} 👋` : 'Partner dashboard'}</div>
                    </div>

                    <div className={`mlux-online ${isOnline ? 'on' : 'off'}`} data-rise="2" onClick={() => !onlineLoading && toggleOnline()}>
                        <div className="ol-tx">
                            <div className="ol-dot" />
                            <div>
                                <div className="ol-title">{isOnline ? "You're online" : "You're offline"}</div>
                                <div className="ol-sub">{isOnline ? 'Visible to customers for two-way trips' : 'Hidden from two-way search'}</div>
                            </div>
                        </div>
                        <div className={`mlux-switch-el ${isOnline ? 'on' : ''}`}><span /></div>
                    </div>

                    <div className="mlux-earn" data-rise="2">
                        <div className="lbl"><i className="far fa-wallet"></i> Total earnings</div>
                        <div className="amt">Rs. {earningsTotal}{hasEstimated ? '*' : ''}</div>
                        <div className="sub">{completedTotal} completed trip{completedTotal === 1 ? '' : 's'}</div>
                    </div>

                    <div className="mlux-stats" style={{ marginTop: 12 }} data-rise="2">
                        <div className="mlux-stat up"><div className="n">{oneWayStats.activeCount}</div><div className="l">Active availabilities</div></div>
                        <div className="mlux-stat"><div className="n">{carcount}</div><div className="l">My cars</div></div>
                        <div className="mlux-stat"><div className="n">{oneWayStats.totalCount}</div><div className="l">All trips</div></div>
                    </div>

                    <div className="mlux-sec-head"><h3>Today's active one-way trips</h3>{todayOneWay.length > 0 && <span style={{ color: 'var(--accent)', fontSize: 13, fontWeight: 800 }}>{todayOneWay.length}</span>}</div>

                    {todayOneWay.length ? todayOneWay.map((a) => {
                        const fare = oneWayFare(a);
                        return (
                            <Link to={`/oneWayAvailabilities/${a.id}`} className="mlux-card mlux-trip" key={a.id} data-rise="3" style={{ display: 'block', color: 'inherit', textDecoration: 'none' }}>
                                <div className="thead">
                                    <div className="car">{a.vendorCar?.Car?.brand} {a.vendorCar?.Car?.name}</div>
                                    <span className="mlux-badge ok">Active</span>
                                </div>
                                <div className="mlux-date"><i className="far fa-calendar"></i>{moment(a.tripDate).format('ddd, DD MMM')}</div>
                                <div className="mlux-route">
                                    <div className="pt from"><small>From</small>{a.from?.full_address || 'N/A'}</div>
                                    <div className="pt to"><small>To</small>{a.to?.full_address || 'N/A'}</div>
                                </div>
                                <div className="tmeta">
                                    <span><i className="far fa-user-group"></i> {a.leadsCount || 0} lead{a.leadsCount === 1 ? '' : 's'}</span>
                                    {fare != null && <span className="cost" style={{ color: '#16a34a', fontWeight: 800 }}>Est. ₹{fare}</span>}
                                </div>
                            </Link>
                        );
                    }) : (
                        <div className="mlux-card mlux-empty" data-rise="3">
                            <div className="ic"><i className="fas fa-route"></i></div>
                            <h4>No one-way trips today</h4>
                            <Link to="/oneWayAvailabilities/add" className="mlux-btn ghost" style={{ textDecoration: 'none' }}><i className="fas fa-plus"></i> Add availability</Link>
                        </div>
                    )}

                    <div className="mlux-sec-head"><h3>Booking requests</h3>{bookingList?.length > 0 && <span style={{ color: 'var(--accent)', fontSize: 13, fontWeight: 800 }}>{bookingList.length} new</span>}</div>

                    {bookingList && bookingList.length ? bookingList.map((item) => (
                        <div className="mlux-card mlux-trip" key={item.id} data-rise="3">
                            <div className="thead">
                                <div>
                                    <div className="car">{item.Car?.brand} {item.Car?.name}</div>
                                    <div className="bid">Booking #{item.id}</div>
                                </div>
                                <span className="status">{item.BookingDetails?.[0]?.bookingStatus}</span>
                            </div>
                            <div className="mlux-date"><i className="far fa-calendar"></i>{moment(item.tripStartDate).format('ddd, DD MMM')}</div>
                            <div className="mlux-route">
                                <div className="pt from"><small>From</small>{item?.BookingDetails?.[0]?.pickupLocation?.addressLine}</div>
                                <div className="pt to"><small>To</small>{item?.BookingDetails?.[0]?.dropLocation?.addressLine}</div>
                            </div>
                            <div className="tmeta">
                                <TripTypeBadge tripType={item.tripType} />
                                <KmBadge item={item} />
                                <span className="cost"><CostHighlight item={item} /></span>
                            </div>
                            <div className="mlux-actions">
                                <button className="mlux-accept" onClick={() => acceptBookingHandler(item)}><i className="far fa-check"></i> Accept</button>
                                <button className="mlux-reject" onClick={() => rejectBookingHandler(item)}><i className="far fa-xmark"></i> Reject</button>
                            </div>
                        </div>
                    )) : (
                        <div className="mlux-card mlux-empty" data-rise="3">
                            <div className="ic"><i className="far fa-bell"></i></div>
                            <h4>No new requests</h4>
                            <p>New booking requests for your cabs will appear here.</p>
                        </div>
                    )}

                    {hasEstimated && <p style={{ color: 'var(--muted)', fontSize: 12, margin: '16px 4px 0' }}>* Total earnings include the estimated fare of completed one-way trips.</p>}
                </main>
                <MobileFooter />
            </>
        );
    }

    return (<>
        <Header />
        <SideBar />
        <main class="main">

            <Toaster
                type={toaster.type}
                title={toaster.title}
                text={toaster.text}
                visiblity={toaster.visiblity}
            />


            <div class="user-profile py-5">
                <div class="container">
                    <div class="row">
                        <DashboardSideBar />
                        <div class="col-lg-9">
                            <div class="">
                                <div class="row">
                                    <div class="col-md-6 col-lg-4 col-6">
                                        <div class="dashboard-widget dashboard-widget-color-1">
                                            <div class="dashboard-widget-info">
                                                <h1>{upcomingbooking}</h1>
                                                <span>Upcoming Booking</span>
                                            </div>
                                            <div class="dashboard-widget-icon">
                                                <i class="fal fa-list"></i>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6 col-lg-4 col-6">
                                        <div class="dashboard-widget dashboard-widget-color-2">
                                            <div class="dashboard-widget-info">
                                                <h1>{completedTotal}</h1>
                                                <span>Completed Booking</span>
                                            </div>
                                            <div class="dashboard-widget-icon">
                                                <i class="fal fa-eye"></i>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6 col-lg-4 col-6">
                                        <div class="dashboard-widget dashboard-widget-color-3">
                                            <div class="dashboard-widget-info">
                                                <h1>{pendingbooking}</h1>
                                                <span>Pending Booking</span>
                                            </div>
                                            <div class="dashboard-widget-icon">
                                                <i class="fal fa-xmark-circle"></i>
                                            </div>
                                        </div>
                                    </div>
                                {/* </div> */}
                                {/* <div class="row"> */}
                                    <div class="col-md-6 col-lg-4 col-6">
                                        <div class="dashboard-widget dashboard-widget-color-3">
                                            <div class="dashboard-widget-info">
                                                <h1>Rs. {earningsTotal}{hasEstimated ? '*' : ''}</h1>
                                                <span>Total Earnings</span>
                                            </div>
                                            <div class="dashboard-widget-icon">
                                                <i class="fal fa-rupee"></i>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6 col-lg-4 col-6">
                                        <div class="dashboard-widget dashboard-widget-color-1">
                                            <div class="dashboard-widget-info">
                                                <h1>{carcount}</h1>
                                                <span>My Cars</span>
                                            </div>
                                            <div class="dashboard-widget-icon">
                                                <i class="fal fa-car"></i>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6 col-lg-4 col-6">
                                        <div class="dashboard-widget dashboard-widget-color-2">
                                            <div class="dashboard-widget-info">
                                                <h1>{oneWayStats.totalCount}</h1>
                                                <span>All Trips</span>
                                            </div>
                                            <div class="dashboard-widget-icon">
                                                <i class="fal fa-route"></i>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6 col-lg-4 col-6">
                                        <div class="dashboard-widget dashboard-widget-color-3">
                                            <div class="dashboard-widget-info">
                                                <h1>{oneWayStats.activeCount}</h1>
                                                <span>Active Availabilities</span>
                                            </div>
                                            <div class="dashboard-widget-icon">
                                                <i class="fal fa-calendar-check"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-lg-12">
                                        <div class="user-profile-card">
                                            <h4 class="user-profile-card-title">Today's Active One-Way Trips</h4>
                                            {todayOneWay.length ? (
                                                <div class="table-responsive">
                                                    <table class="table text-nowrap">
                                                        <thead>
                                                            <tr>
                                                                <th>Car</th>
                                                                <th>From</th>
                                                                <th>To</th>
                                                                <th>Trip Date</th>
                                                                <th>Est. Fare</th>
                                                                <th>Leads</th>
                                                                <th>Action</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {todayOneWay.map((a) => {
                                                                const fare = oneWayFare(a);
                                                                return (
                                                                    <tr key={a.id}>
                                                                        <td>{a.vendorCar?.Car?.brand} {a.vendorCar?.Car?.name}</td>
                                                                        <td style={{ whiteSpace: 'normal', minWidth: 160 }}>{a.from?.full_address || 'N/A'}</td>
                                                                        <td style={{ whiteSpace: 'normal', minWidth: 160 }}>{a.to?.full_address || 'N/A'}</td>
                                                                        <td>{moment(a.tripDate).format('DD-MM-YYYY, hh:mm A')}</td>
                                                                        <td>{fare != null ? `Rs. ${fare}` : '-'}</td>
                                                                        <td>{a.leadsCount || 0}</td>
                                                                        <td>
                                                                            <Link to={`/oneWayAvailabilities/${a.id}`} class="btn btn-outline-secondary btn-sm rounded-2" title="View Details"><i class="far fa-eye"></i></Link>
                                                                        </td>
                                                                    </tr>
                                                                );
                                                            })}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            ) : (
                                                <div class="text-center py-4">
                                                    <p class="mb-3">No one-way trips today</p>
                                                    <Link to="/oneWayAvailabilities/add" class="theme-btn"><i class="far fa-plus"></i> Add availability</Link>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-lg-12">
                                        <div class="user-profile-card">
                                            <h4 class="user-profile-card-title">Booking Requests</h4>
                                            {isMobile ? <div class="container my-3">

                                                {bookingList?.map((item) => {
                                                    return (<div  class="card booking-card">
                                                        <div class="d-flex justify-content-between align-items-center">

                                                            <div class="booking-info">
                                                                <h6 className="mb-0">{item.Car.brand} {item.Car.name}</h6>
                                                                <span>Booking ID: #{item.id}</span>
                                                            </div>
                                                            <img src={constant.IMAGE_URL + item?.VendorCar.photos[0]} crossorigin="anonymous" class="rounded-circle" alt="Driver image" />
                                                        </div>
                                                        <div className="d-flex justify-content-between">
                                                            <div class="mt-1">
                                                                <span><strong>From : </strong>{item?.BookingDetails[0].pickupLocation.addressLine}</span> <br />
                                                                <span><strong>to : </strong>{item?.BookingDetails[0].dropLocation.addressLine}</span>
                                                            </div>
                                                            <div class="mt-1">
                                                                <span>{moment(item.tripStartDate).format('DD/MM/YY')}</span>
                                                                <p>{moment(item.tripEndDate).format('DD/MM/YY')}</p>
                                                            </div>
                                                        </div>

                                                        <div class="d-flex justify-content-between mt-2">
                                                            <span class={`badge badge-status badge-${(item.bookingStatus == 'failed' || item.bookingStatus == 'cancelled' || item.bookingStatus == 'rejected') ? 'danger' : 'primary'} text-capitalize`}>{(item.bookingStatus == 'failed' || item.bookingStatus == 'cancelled' || item.bookingStatus == 'rejected') ? item.bookingStatus : item.BookingDetails[0].bookingStatus}</span>
                                                            <span style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', flexWrap: 'wrap' }}><TripTypeBadge tripType={item.tripType} /><KmBadge item={item} /><CostHighlight item={item} /></span>
                                                        </div>
                                                        <div class="d-flex justify-content-between mt-3">
                                                        <button onClick={() => acceptBookingHandler(item)}
                                                                            class="btn btn-success btn-sm rounded-2 me-2"
                                                                            data-bs-toggle="tooltip" title="Details"> <i
                                                                                class="far fa-check"></i> Accept </button>
                                                                        <button onClick={() => rejectBookingHandler(item)}
                                                                            class="btn btn-danger btn-sm rounded-2"
                                                                            data-bs-toggle="tooltip" title="Details"> <i
                                                                                class="far fa-multiply"></i> Reject </button>
                                                        </div>

                                                    </div>)
                                                })}



                                            </div>
                                                : <div class="table-responsive">
                                                    <table class="table text-nowrap">
                                                        <thead>
                                                            <tr>
                                                                <th className="">Cab Info</th>
                                                                <th>Journey Date</th>
                                                                <th>Pickup and drop</th>
                                                                <th>Trip / KM</th>
                                                                <th>Price</th>
                                                                <th>Status</th>
                                                                {/* <th style={{minWidth:'170px'}}>Driver</th> */}
                                                                <th>Action</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {bookingList?.map((item) => {
                                                                return (<tr key={item.id}>
                                                                    <td>
                                                                        <div class="table-list-info">
                                                                            <a href="#">
                                                                                {/* <img src="/assets/img/taxi/01.png" alt/> */}
                                                                                <div class="table-list-content">
                                                                                    <h6>{item.Car.brand} {item.Car.name}</h6>
                                                                                    <span>Booking ID: #{item.id}</span>
                                                                                </div>
                                                                            </a>
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        <span>{moment(item.tripStartDate).format('DD/MM/YY')}</span>
                                                                        <p>{moment(item.tripEndDate).format('DD/MM/YY')}</p>
                                                                    </td>
                                                                    <td>
                                                                        <span>{item?.BookingDetails[0].pickupLocation.addressLine}</span> <br />
                                                                        <span>{item?.BookingDetails[0].dropLocation.addressLine}</span>
                                                                        {/* <p>03:15 PM</p> */}
                                                                    </td>
                                                                    <td><div className="d-flex flex-column align-items-start" style={{ gap: '4px' }}><TripTypeBadge tripType={item.tripType} /><KmBadge item={item} /></div></td>
                                                                    <td><CostHighlight item={item} /></td>
                                                                    <td><span class={`badge badge-${(item.bookingStatus == 'failed' || item.bookingStatus == 'cancelled' || item.bookingStatus == 'rejected') ? 'danger' : 'primary'} text-capitalize`}>{(item.bookingStatus == 'failed' || item.bookingStatus == 'cancelled' || item.bookingStatus == 'rejected') ? item.bookingStatus : item.BookingDetails[0].bookingStatus}</span></td>
                                                                    {/* <td> <select onChange={(e)=>setSelectedDriver(e.target.value)}  class="form-control">
                                                                <option>Select</option>
                                                               
                                                                {driverList && driverList.length && driverList.map((item)=> {return (
                                                                     <option value={item.id}>{item.firstName} {item.lastName}</option>
                                                                )})}
                                                           </select></td> */}
                                                                    <td>
                                                                        <button onClick={() => acceptBookingHandler(item)}
                                                                            class="btn btn-success btn-sm rounded-2 me-2"
                                                                            data-bs-toggle="tooltip" title="Details"> <i
                                                                                class="far fa-check"></i> Accept </button>
                                                                        <button onClick={() => rejectBookingHandler(item)}
                                                                            class="btn btn-danger btn-sm rounded-2"
                                                                            data-bs-toggle="tooltip" title="Details"> <i
                                                                                class="far fa-multiply"></i> Reject </button>

                                                                    </td>
                                                                </tr>)
                                                            })}

                                                        </tbody>
                                                    </table>
                                                </div>}
                                        </div>
                                        {hasEstimated && <p class="text-muted small mt-3">* Total earnings include the estimated fare of completed one-way trips.</p>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </main>
        <Footer />
    </>
    )
}
export default Dashboard